import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgSettings = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "inherit",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M18.877 13.16a7.21 7.21 0 0 0 .064-.908c0-.314-.027-.61-.064-.906l1.952-1.527a.467.467 0 0 0 .11-.592l-1.85-3.201c-.11-.204-.36-.278-.564-.204l-2.304.925a6.76 6.76 0 0 0-1.563-.906l-.352-2.452A.451.451 0 0 0 13.853 3h-3.701a.451.451 0 0 0-.454.389L9.347 5.84a7.109 7.109 0 0 0-1.564.906l-2.304-.925a.451.451 0 0 0-.564.204l-1.85 3.2a.456.456 0 0 0 .11.593l1.952 1.527a7.338 7.338 0 0 0-.064.906c0 .306.027.611.064.907l-1.952 1.527a.467.467 0 0 0-.11.592l1.85 3.201c.11.204.36.278.564.204l2.304-.925c.481.37 1 .675 1.564.906l.351 2.452a.451.451 0 0 0 .454.389h3.7a.451.451 0 0 0 .454-.389l.352-2.452a7.109 7.109 0 0 0 1.563-.906l2.304.925c.213.083.453 0 .564-.204l1.85-3.201a.467.467 0 0 0-.11-.592l-1.952-1.527zm-6.875 2.33a3.242 3.242 0 0 1-3.238-3.238 3.242 3.242 0 0 1 3.238-3.238 3.242 3.242 0 0 1 3.238 3.238 3.242 3.242 0 0 1-3.238 3.239z",
			fillRule: "nonzero"
		})
	})
});
export default SvgSettings;
